export default "/packs/images/stretch~3c2f401529f5cb2d4c3d757d83f99770.jpg";